<template>
  <div class="systemNotifications-page">
    <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/A80947FD-B99C-491D-AAF9-B132F77725B3.png" />
  </div>
</template>

<script>
export default {
  name: 'systemNotifications',
};
</script>

<style scoped>
  .systemNotifications-page{
    width: 100%;
    min-height: 100vh;
    background: #ffffff;
  }
  .systemNotifications-page img{
    width: 100%;
  }
</style>
